<template>
    <Divider />
    <div class="field grid">
        <label for="email" class="col-2 mb-4" :class="{'p-invalid' : errors.email}">Jenis Role </label>
        <div class="col-4 md:col-4">
            <Dropdown v-model="temp.role" :options="list_roles" optionLabel="name" @change="setInputRole()"/>
            <small v-if="errors.role" id="name-help" class="p-error">{{errors.role}}</small>
        </div>
        <label for="email" class="col-2" > Di : </label>
    </div>  
    <DropdownWilayah v-model="temp.area" :level="temp.level"/> 
    <div class="field grid" v-if="temp.select_type == 'kua'">
        <label for="kua" class="col-12 mb-2 md:col-2 md:mb-0" :class="{'p-invalid' : errors.kua}">KUA </label>
        <div class="col-12 md:col-10">
            <Dropdown id="kua" :options="list_kua" :dropdown="true" v-model="temp.area.selected_kua" optionLabel="nama_kua"/>
            <small v-if="errors.kua" id="name-help" class="p-error">{{errors.kua}}</small>
        </div>
    </div>
    <div class="field grid">
        <label for="email" class="col-2 mb-4" :class="{'p-invalid' : errors.email}"> </label>
        <div class="col-4 md:col-4">
            <Button label="Tambah" :disabled="temp.role == null || temp.area == null" @click="addRole()" />
        </div>
    </div>  
    <div class="field grid">
        <label for="email" class="col-2 mb-4" :class="{'p-invalid' : errors.email}">Role Terpilih </label>
        <div class="col-10 md:col-10">
            <DataTable :value="modelValue" >
                <Column header="Role" field="role">
                    <template #body="slotProps">
                        <span>{{slotProps.data.role.name}}</span>
                    </template>
                </Column>
                <Column header="Di" field="role">
                    <template #body="slotProps">
                        <span>{{parseViewArea(slotProps.data)}}</span>
                    </template>
                </Column>
                <Column header="Aksi">
                    <template #body="slotProps">
                        <Button  icon="pi pi-times" class="p-button-rounded p-button-danger" @click="removeRole(slotProps)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>  
    <Divider />
</template>

<script>
import axios from 'axios';
import Dropdown from 'primevue/dropdown';
import Divider from 'primevue/divider';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import DropdownWilayah from '../../../Components/DropdownWilayah.vue';

export default {
    props : {
        modelValue : {
            type : Object,
            default : null
        },
        errors : {
            type : Object,
            default : {
                email : null
            }
        },
    },
    components: {
    Dropdown,
    Divider,
    Button,
    DataTable,
    Column,
    DropdownWilayah
},
    data() {
        return {
            list_roles: [],
            list_kua: [],
            temp : {
                role : null,
                area : {
                    selected_propinsi : null,
                    selected_kabupaten : null,
                    selected_kecamatan : null,
                    selected_kelurahan : null
                },
                kua : '',
                level : '',
                select_type : '',
            },
        };
    },
    mounted() {
        this.getListRoles();
    },
    methods: {
        getListRoles() {
            axios.get('/roles/list_all_assignable_roles')
            .then(response => {
                this.list_roles = response.data.data;
            })
            .catch(error => {
                console.log(error);
            });
        },
        parseViewArea(data){
            console.log(data);
            if (data.level == 'propinsi' && data.select_type == 'wilayah'){
                return data.area.selected_propinsi.nama;
            }
            if (data.level == 'kabupaten' && data.select_type == 'wilayah'){
                return data.area.selected_kabupaten.nama + ' - ' + data.area.selected_propinsi.nama;
            }
            if (data.select_type == 'kua'){
                return data.area.selected_kua.nama_kua + ' - ' + data.area.selected_kabupaten.nama + ' - ' + data.area.selected_propinsi.nama;
            }
        },
        setInputRole() {
            if (this.temp.role['kode'] == 'admin_propinsi'){
                this.temp.level = 'propinsi';
                this.temp.select_type = 'wilayah';
            }else if (this.temp.role['kode'] == 'admin_kabupaten'){
                this.temp.level = 'kabupaten';
                this.temp.select_type = 'wilayah';
            }else if (this.temp.role['kode'] == 'admin_kua'){
                this.temp.level = 'kabupaten';
                this.temp.select_type = 'kua';
            }
        },
        addRole() {

            // create new clone of this.temp
            let temp = JSON.parse(JSON.stringify(this.temp));
            this.modelValue.push(temp);

            if (this.temp.role['kode'] == 'admin_propinsi'){
                this.temp.area.selected_propinsi = this.temp.area.selected_propinsi;
                this.temp.area.selected_kabupaten = null;
                this.temp.area.selected_kecamatan = null;
                this.temp.area.selected_kelurahan = null;
                this.temp.area.selected_kua = null;
            }else if (this.temp.role['kode'] == 'admin_kabupaten'){
                this.temp.area.selected_propinsi = this.temp.area.selected_propinsi;
                this.temp.area.selected_kabupaten = null;
                this.temp.area.selected_kecamatan = null;
                this.temp.area.selected_kelurahan = null;
                this.temp.area.selected_kua = null;
            }else if (this.temp.role['kode'] == 'admin_kua'){
                this.temp.area.selected_propinsi = this.temp.area.selected_propinsi;
                this.temp.area.selected_kabupaten = null;
                this.temp.area.selected_kecamatan = null;
                this.temp.area.selected_kelurahan = null;
                this.temp.area.selected_kua = null;
            }

            this.temp = {
                role : null,
                area : {
                    selected_propinsi : null,
                    selected_kabupaten : null,
                    selected_kecamatan : null,
                    selected_kelurahan : null,
                    selected_kua : null,
                },
                level : '',
                kua : ''
            };
        },
        removeRole(slotProps) {
            this.modelValue.splice(slotProps.index, 1);
        },
        getListKUA(){
            axios.get('/api/wilayah/kua_by_kode/' + this.temp.area.selected_kabupaten.kode)
            .then(response => {
                this.list_kua = response.data;
            })
            .catch(error => {
                console.log(error);
            });
        },
    },
    computed : {
        model : {
            get() {
                return this.modelValue;
            },
            set(value) {
                // console.log(value);
                this.$emit('update:modelValue', value);
            }
        }
    },
    // watch if selected_kabupaten is changed, using handler and deep = true
    watch : {
        'temp.area.selected_kabupaten' : {
            handler(newValue, oldValue) {
                if (newValue != null){
                    this.getListKUA();
                }
            },
            deep : true
        },
    },
}
</script>

<style>

</style>